<script lang="ts">
  import { onMount } from "svelte";
  import { GuidedScene } from "./GuidedScene";
  import TrialScene from "./TrialScene.svelte";
  import WindowData from "./WindowData.svelte";
  import { GuidedSceneSettingIds } from "./GuidedSceneSettings";

  export let sceneName: string;

  let scene = null;
  onMount(async () => {
    const encodedSceneName = encodeURIComponent(sceneName);
    fetch(`/api/public/trial_scene/${encodedSceneName}`)
      .then((response) => response.json())
      .then((publicScene) => {
        const parsed = JSON.parse(publicScene.Data);
        scene = new GuidedScene(parsed);
        scene.settings.setValue(
          GuidedSceneSettingIds.MusicCrossfadeEnabled,
          true,
        );
        scene.settings.setValue(
          GuidedSceneSettingIds.StartMusicWhenStartingScene,
          true,
        );
        scene.bannerUrl = publicScene.BannerUrl;
      })
      .catch((error) => {
        return [];
      });
  });
</script>

{#if scene}
  <WindowData />
  <TrialScene {scene} />
{/if}
